require('./Zen.scss');

const b = require('app/www/libs/b')('zen');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');
const randomString = require('app/www/libs/randomString');

const LOADER_URL = '//yastatic.net/s3/zen-lib/2.5.525/loader/loader.legacy.bundle.js';
const id = 'zen';

class Zen extends React.PureComponent {

    constructor(props) {
        super(props);

        this._loadScript = this._loadScript.bind(this);
    }

    componentDidMount() {
        this.block.id = randomString();

        this._loadScript();
    }

    render() {
        const {i18n} = this.props;

        return (
            <div className={b()} data-url={LOADER_URL} ref={ref => (this.block = ref)}>
                <div className={b('titles')}>
                    <div className={b('title')}>{i18n.get('zen.title')}</div>
                    <div className={b('sub-title')}>{i18n.get('zen.sub-title')}</div>
                </div>
                <div id={id} />
            </div>
        );
    }

    /**
     * Грузим скрипт Zen
     * @private
     */
    _loadScript() {
        const {
            params,
        } = this.props;

        ((w, d) => {
            const createScript = () => {
                const t = d.getElementsByTagName('script')[0];
                const s = d.createElement('script');
                s.src = LOADER_URL;
                s.type = 'text/javascript';
                s.async = true;
                t.parentNode.insertBefore(s, t);
                s.onload = () => {
                    window.YandexZen.loader.create(params)
                        .then((lib) => {
                            lib.render(document.getElementById('zen'));
                        });
                };
            };

            if (d.readyState === 'complete') {
                createScript();
            } else if (d.addEventListener) {
                w.addEventListener('load', createScript);
            } else {
                w.attachEvent('onload', createScript);
            }
        })(window, document);
    }
}

Zen.propTypes = {
    params: PropTypes.object,
};

module.exports = withI18n(Zen);
